/* ==========================================================================
   Collectie slider

   Het scrollen zelf doet CSS: scroll-snap plus overflow-x. Deze file voegt
   alleen de pijlen toe. Daarom staan die knoppen in de markup op hidden en
   worden ze hier zichtbaar gemaakt: geen JavaScript betekent geen dode
   knoppen, en swipen werkt sowieso.
   ========================================================================== */

class CollectieSlider extends HTMLElement {
  connectedCallback() {
    this.spoor = this.querySelector('[data-cs-spoor]');
    this.knoppen = this.querySelector('[data-cs-knoppen]');
    if (!this.spoor || !this.knoppen) return;

    this.vorige = this.querySelector('[data-cs-richting="vorige"]');
    this.volgende = this.querySelector('[data-cs-richting="volgende"]');

    // Alleen tonen als er echt iets te scrollen valt
    this.controleer = this.controleer.bind(this);
    this.knoppen.hidden = false;

    /* Eén signaal voor alle listeners, afgebroken in disconnectedCallback.
       De theme editor verplaatst een sectie bij het herschikken, en dan
       draait connectedCallback opnieuw. Zonder dit kwamen er telkens
       klik-listeners bij en schoof één klik twee of drie keer zo ver. */
    this.afbreker = new AbortController();
    const { signal } = this.afbreker;

    this.vorige?.addEventListener('click', () => this.schuif(-1), { signal });
    this.volgende?.addEventListener('click', () => this.schuif(1), { signal });

    this.spoor.addEventListener('scroll', this.controleer, { passive: true, signal });

    // Bij resize verandert hoeveel kaarten er passen
    this.observer = new ResizeObserver(this.controleer);
    this.observer.observe(this.spoor);

    this.controleer();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.afbreker?.abort();
  }

  /* Eén schermbreedte per klik, min één kaart overlap zodat de gebruiker
     ziet waar hij gebleven is. */
  schuif(richting) {
    const kaart = this.spoor.querySelector('.cs__item');
    const kaartBreedte = kaart ? kaart.getBoundingClientRect().width + 16 : 200;
    const zichtbaar = Math.max(1, Math.floor(this.spoor.clientWidth / kaartBreedte) - 1);

    this.spoor.scrollBy({
      left: richting * kaartBreedte * zichtbaar,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth',
    });
  }

  controleer() {
    const { scrollLeft, scrollWidth, clientWidth } = this.spoor;
    // Marge van 2px: browsers ronden scrollLeft af en dan blijft de knop
    // ten onrechte actief op het einde van de rij.
    const aanBegin = scrollLeft <= 2;
    const aanEinde = scrollLeft + clientWidth >= scrollWidth - 2;
    const past = scrollWidth <= clientWidth + 2;

    this.knoppen.hidden = past;

    if (this.vorige) this.vorige.disabled = aanBegin;
    if (this.volgende) this.volgende.disabled = aanEinde;
  }
}

if (!customElements.get('collectie-slider')) {
  customElements.define('collectie-slider', CollectieSlider);
}

/* Theme editor: blok toevoegen of herschikken hertekent de sectie */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelector('collectie-slider')?.controleer?.();
});